/**
 * Risk-adjusted return: window return per unit of annualised volatility (F13).
 *
 * A derivation, not a format — `core` owns it so there is exactly one
 * implementation, the same reason `risk_score` is never stored. Returns `null`
 * rather than 0 for a missing input: a name with no volatility reading does not
 * have a risk-adjusted return of zero (R2b).
 */
export function returnVolRatio(ret: number | null, vol: number | null): number | null {
  if (ret === null || vol === null) return null;
  if (!Number.isFinite(ret) || !Number.isFinite(vol)) return null;
  const ratio = ret / vol;
  /* Guard the RESULT, not just `vol === 0`. A denormal volatility (5e-324) is
     non-zero yet still overflows the division to ±Infinity — found by the
     fast-check property below, and previously rendered as the string
     "Infinity" by the web-side helper this replaces. */
  return Number.isFinite(ratio) ? ratio : null;
}
